import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { TeflLecComment } from '../../../lib/types/models/tefl-lec-comment/tefl-lec-comment'
import { TeflLecCommentFilters } from '../../../lib/types/models/tefl-lec-comment/tefl-lec-input'
import { encodeNestedObject } from '../../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getTeflLecComments(
  input: PaginationRequest<TeflLecCommentFilters> & { teflId: number }
) {
  const { teflId, ...rest } = input
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest>(
        constructApiUrl(API.tefl.getTeflLecComments.url, { teflId }),
        rest
      )
    )
    .get<PaginationResponse<TeflLecComment>>()
}
